import React, { useState } from 'react';

// insert values are LaTeX strings passed to MathLive's el.insert()
// #? = placeholder (Tab to jump between them)
const BUTTONS = [
  { display: 'a/b', title: 'fraction',              insert: '\\frac{#?}{#?}' },
  { display: 'xⁿ',  title: 'power',                 insert: '^{#?}'          },
  { display: '√',   title: 'square root',           insert: '\\sqrt{#?}'     },
  { display: 'ⁿ√',  title: 'nth root',              insert: '\\sqrt[#?]{#?}' },
  { display: '≤',   title: 'less than or equal',    insert: '\\le'           },
  { display: '≥',   title: 'greater than or equal', insert: '\\ge'           },
  { display: 'π',   title: 'pi',                    insert: '\\pi'           },
  { display: '°',   title: 'degrees',               insert: '^\\circ'        },
  { display: '∞',   title: 'infinity',              insert: '\\infty'        },
  { display: '()',  title: 'parentheses',           insert: '(#?)'           },
  { display: '{}',  title: 'curly braces',          insert: '\\{#?\\}'       },
];

const MathSymbolKeyboard = ({ onSymbolClick }) => {
  const [open, setOpen] = useState(false);

  const buttons = (
    <div className="flex flex-wrap sm:flex-nowrap gap-1 mt-1.5">
      {BUTTONS.map(({ display, title, insert }) => (
        <button
          key={display}
          type="button"
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onSymbolClick(insert)}
          title={title}
          className="h-7 min-w-[2rem] px-2 flex items-center justify-center rounded-md
            bg-gray-100 hover:bg-gray-200 active:bg-gray-300
            text-gray-700 text-xs font-medium transition-colors select-none"
        >
          {display}
        </button>
      ))}
    </div>
  );

  return (
    <div className="w-full">
      {/* Mobile: collapsible toggle */}
      <div className="sm:hidden">
        <button
          type="button"
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-1.5 rounded-md border border-gray-200 bg-gray-50 px-2.5 py-1 text-xs text-gray-500 font-medium hover:bg-gray-100 transition-colors select-none"
        >
          <span className="text-gray-400 font-normal tracking-tight">a/b √ ±</span>
          <span>{open ? 'Hide' : 'Insert symbol'}</span>
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            className={`w-3 h-3 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          >
            <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06z" clipRule="evenodd" />
          </svg>
        </button>
        {open && buttons}
      </div>

      {/* Desktop: always visible */}
      <div className="hidden sm:block">
        <p className="text-gray-400 text-xs mb-1.5 font-normal">Symbols — click to insert</p>
        {buttons}
      </div>
    </div>
  );
};

export default MathSymbolKeyboard;
